export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/erik-lucatero-1-48eb01ff4ef9d99ffdf9912c6362f688.jpg";